import React from "react";

function Marketplace() {

    return (
    
    
        <section id="Marketplace-section">
    <div className="wrapper">

    <div className="marketplaceTextContent">
            <h2 className="sectionTitle">Marketplace coming soon</h2>
          </div>




    </div>
    </section>



    );
}
    export default Marketplace;